import { FC } from 'react';
import styles from './selectItem.module.scss';
import { SelectItemProps } from './selectItemTypes';
import { CheckBoxIcon, CheckBoxOutlineBlankIcon } from '../../uiLibraryImports';

const SelectItem: FC<SelectItemProps> = (props: SelectItemProps) => {
    const { name, displayName, onChange, isSelected = false } = props;

    const onSelect = e => {
        onChange(e, name);
    };

    return (
        <div data-testid="select-item" className={styles['select-item']} onClick={onSelect}>
            {isSelected ? (
                <CheckBoxIcon fontSize={'medium'} htmlColor={'#BAA7D8'} />
            ) : (
                <CheckBoxOutlineBlankIcon fontSize={'medium'} htmlColor={'#D7D8DB'} />
            )}
            <span className={styles.title}>{displayName}</span>
        </div>
    );
};

export default SelectItem;
